/* Block - Hero.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 */
/* eslint-disable-next-line */
import styles from "./block-hero.scss";
import rsCarousel from '../../js/component/_carousel-hero';
const carousels = Array.from(document.querySelectorAll('body:not(.wp-admin) .rs-hero-carousel'));
rsCarousel.init(carousels);

jQuery(document).ready(function() {
    jQuery('.rs-announcement__container').each(function() {
        const $container = jQuery(this);
        const $heroAnnouncements = $container.find('.rs-announcement');

        if (!$heroAnnouncements.length) {
            return;
        }

        $heroAnnouncements.first().addClass('active').css('z-index', 3);

        if ($heroAnnouncements.length < 2) {
            return;
        }

        function cycleAnnouncements() {
            const $activeAnnouncement = $container.find('.rs-announcement.active');
            const $nextAnnouncement = ($activeAnnouncement.next('.rs-announcement').length > 0) ? $activeAnnouncement.next('.rs-announcement') : $heroAnnouncements.first();
            $activeAnnouncement.fadeOut(1500, function() {
                $activeAnnouncement.css('z-index', 1).removeClass('active');
            });
            $nextAnnouncement.fadeTo(1500, 1, function() {
                $nextAnnouncement.css('z-index', 3).addClass('active');
            });
        }

        setInterval(cycleAnnouncements, 7000);
    });
});
